import styled from "styled-components";

import { Input } from "antd";

export const LSUnderLineInput = styled(Input)`
    border-radius: 0 !important;
    border-top: none;
    border-left: none;
    border-right: none;

    &.ant-input-status-error {
        &:focus {
            box-shadow: none !important;       
        }
    }

    &:focus {
        box-shadow: none;
    }

    &::placeholder {
        font-style: italic;
    }
`;